import { router } from "@inertiajs/react"
import { useEffect } from "react"
import { toast } from "sonner"

import type { FlashData } from "@/types"

function showFlash(flash: FlashData) {
  if (flash.notice) toast.success(flash.notice, { id: "flash-notice" })
  if (flash.alert) toast.error(flash.alert, { id: "flash-alert" })
}

export function FlashToaster({ flash = {} }: { flash?: FlashData }) {
  useEffect(() => {
    showFlash(flash)

    return router.on("flash", (event) => showFlash(event.detail.flash))
  }, [flash])

  return null
}
